// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Fetch = require("bs-fetch/src/Fetch.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.bs.js");
var $$Notification = require("./Notification.bs.js");
var Caml_exceptions = require("bs-platform/lib/js/caml_exceptions.js");

var UnexpectedResponse = Caml_exceptions.create("Api.UnexpectedResponse");

function apiErrorTitle(x) {
  if (x.RE_EXN_ID === UnexpectedResponse) {
    return String(x._1);
  } else {
    return "An unexpected error occurred";
  }
}

function acceptOrRejectResponse(response) {
  if (response.ok || response.status === 422) {
    return response.json();
  } else {
    return Promise.reject({
                RE_EXN_ID: UnexpectedResponse,
                _1: response.status
              });
  }
}

function handleResponseError(error) {
  var title = apiErrorTitle(error);
  return $$Notification.error(title, "Our team has been notified of this error. Please reload the page and try again.");
}

function handleResponseJSON(json, responseCB, errorCB, notify) {
  var error = Json_decode.optional((function (param) {
          return Json_decode.field("error", Json_decode.string, param);
        }), json);
  if (error !== undefined) {
    if (notify) {
      $$Notification.error("Something went wrong!", error);
    }
    return Curry._1(errorCB, undefined);
  } else {
    return Curry._1(responseCB, json);
  }
}

function handleResponse(responseCB, errorCB, notifyOpt, promise) {
  var notify = notifyOpt !== undefined ? notifyOpt : true;
  promise.then(acceptOrRejectResponse).then(function (json) {
          return Promise.resolve(handleResponseJSON(json, responseCB, errorCB, notify));
        }).catch(function (error) {
        Curry._1(errorCB, undefined);
        console.log(error);
        return Promise.resolve(notify ? handleResponseError(error) : undefined);
      });
  
}

function sendPayload(url, payload, responseCB, errorCB, method_) {
  var param;
  var param$1 = fetch(url, Fetch.RequestInit.make(method_, {
              "Content-Type": "application/json"
            }, Caml_option.some(JSON.stringify(payload)), undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined));
  return handleResponse(responseCB, errorCB, param, param$1);
}

function sendFormData(url, formData, responseCB, errorCB) {
  var param;
  var param$1 = fetch(url, Fetch.RequestInit.make(/* Post */2, undefined, Caml_option.some(formData), undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined));
  return handleResponse(responseCB, errorCB, param, param$1);
}

function get(url, responseCB, errorCB, notify) {
  return handleResponse(responseCB, errorCB, notify, fetch(url));
}

function create(url, payload, responseCB, errorCB) {
  return sendPayload(url, payload, responseCB, errorCB, /* Post */2);
}

function update(url, payload, responseCB, errorCB) {
  return sendPayload(url, payload, responseCB, errorCB, /* Patch */8);
}

exports.UnexpectedResponse = UnexpectedResponse;
exports.apiErrorTitle = apiErrorTitle;
exports.acceptOrRejectResponse = acceptOrRejectResponse;
exports.handleResponseError = handleResponseError;
exports.handleResponseJSON = handleResponseJSON;
exports.handleResponse = handleResponse;
exports.sendPayload = sendPayload;
exports.sendFormData = sendFormData;
exports.get = get;
exports.create = create;
exports.update = update;
/* Notification Not a pure module */
